import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "card-title-container" }
const _hoisted_2 = {
  key: 0,
  class: "cl-card-parent-title"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "cl-card-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.parentKeys.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parentKeys, (key, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: `${key}-${index}`
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t(key)) + " ", 1),
              (index < _ctx.parentKeys.length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " / "))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _cache[0] || (_cache[0] = _createElementVNode("span", null, " / ", -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.currentKey)), 1)
  ]))
}